<template>
  <v-chip-group v-model="selected" show-arrows class="tag-group">
    <v-chip
      v-for="tag in tags"
      :key="tag"
      label
      small
      outlined
      :value="tag"
      @click.stop="tagClicked(tag)"
    >
      {{ tag }}
    </v-chip>
  </v-chip-group>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    selected: [],
  }),
  watch: {
    selected() {
      if (this.selected.length) this.selected = []
    },
  },
  methods: {
    tagClicked(tag) {
      this.$emit('tagClicked', tag)
    },
  },
}
</script>

<style lang="scss">
.tag-group {
  max-width: 300px;
  .v-slide-group__content {
    padding: 0 !important;
  }
}
</style>
